// frontend/src/components/OnboardGuard.jsx
import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { OnboardingContext } from '../contexts/OnboardingContext';

const routeMap = {
  welcome: '/welcome',
  choose_plan: '/choose-plan',
  connect_bank: '/connect-bank',
  review_detected: '/review-detected',
  complete: '/dashboard',
};

export default function OnboardGuard({ currentStep, children }) {
   const { onboardingStep } = useContext(OnboardingContext);
   const navigate = useNavigate();
   const location = useLocation();

   const loading = onboardingStep == null;
   const mismatch = !loading && onboardingStep !== currentStep;
   const target = mismatch ? (routeMap[onboardingStep] || '/') : null;

   useEffect(() => {
       if (!mismatch || !target) return;
       if (location.pathname === target) return;
       navigate(target, { replace: true });
   }, [mismatch, target, location.pathname, navigate, currentStep]);

   if (loading) return children;
   if (mismatch) return null;
   return <>{children}</>;
}
